import { render, staticRenderFns } from "./lyfx.vue?vue&type=template&id=c6ce2eac&scoped=true"
import script from "./lyfx.vue?vue&type=script&lang=js"
export * from "./lyfx.vue?vue&type=script&lang=js"
import style0 from "./lyfx.vue?vue&type=style&index=0&id=c6ce2eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ce2eac",
  null
  
)

export default component.exports